var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { PageService } from "~/utils/page.service";
import { Dependencies } from "~/core/decorator";
import { OutsourceStayService } from "~/services/domain-service/outsource-stay-manage.service";
var EntrustedCase = /** @class */ (function (_super) {
    __extends(EntrustedCase, _super);
    function EntrustedCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = []; //选中的数据
        _this.dataSet = []; //受托方列表数据
        _this.dialog = {
            caseDistribution: false
        };
        return _this;
    }
    EntrustedCase.prototype.emitClose = function () {
        this.selectionList = [];
        this.refresh();
    };
    EntrustedCase.prototype.emitSuccess = function (val) { };
    EntrustedCase.prototype.refresh = function () {
        var _this = this;
        // 默认加载列表
        this.outsourceStayService
            .searchOutsourcePreview(this.isLawsuit, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    Object.defineProperty(EntrustedCase.prototype, "commissionIds", {
        // private mounted() {
        //   this.refresh();
        // }
        get: function () {
            return this.selectionList.map(function (v) { return v.outsourceId; });
        },
        enumerable: false,
        configurable: true
    });
    EntrustedCase.prototype.onClose = function () {
        this.dialog.caseDistribution = false;
        this.emitClose();
    };
    EntrustedCase.prototype.confirm = function () {
        if (this.selectionList.length === 0) {
            this.$message("请选择受托方");
            return;
        }
        this.emitSuccess(this.selectionList);
    };
    __decorate([
        Dependencies(PageService)
    ], EntrustedCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(OutsourceStayService)
    ], EntrustedCase.prototype, "outsourceStayService", void 0);
    __decorate([
        Prop({ required: true })
    ], EntrustedCase.prototype, "isLawsuit", void 0);
    __decorate([
        Emit("close")
    ], EntrustedCase.prototype, "emitClose", null);
    __decorate([
        Emit('success')
    ], EntrustedCase.prototype, "emitSuccess", null);
    EntrustedCase = __decorate([
        Component({
            components: {}
        })
    ], EntrustedCase);
    return EntrustedCase;
}(Vue));
export default EntrustedCase;
